import { render, staticRenderFns } from "./statusUpdateRecord.vue?vue&type=template&id=fdcdf220&scoped=true"
import script from "./statusUpdateRecord.vue?vue&type=script&lang=js"
export * from "./statusUpdateRecord.vue?vue&type=script&lang=js"
import style0 from "./statusUpdateRecord.vue?vue&type=style&index=0&id=fdcdf220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcdf220",
  null
  
)

export default component.exports